import { ElMessage, ElMessageBox } from 'element-plus'
const message = {
  error: (text) => {
    ElMessage({
      showClose: true,
      message: text,
      type: 'error'
    })
  },
  warning: (text) => {
    ElMessage({
      showClose: true,
      message: text,
      type: 'warning'
    })
  },
  success: (text) => {
    ElMessage({
      showClose: true,
      message: text,
      type: 'success'
    })
  },
  confirm: (content, title, type) => {
    return new Promise((resolve) => {
      if (!type) {
        type = 'warning'
      }
      if (!title) {
        title = '提示'
      }
      ElMessageBox.confirm(
        content,
        title,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: type
        }
      ).then((state) => {
        if (state === 'confirm') {
          resolve(true)
        }
        resolve(false)
      }).catch(() => { resolve(false) })
    })
  },
  toast: (text) => {
    ElMessage({
      customClass: 'toast-msg', // 自定义样式，详见：base.css
      offset: 300,
      duration: 1000,
      showClose: false,
      message: text
    })
  }
}
export default message
